import { LoginFormCard } from "@/features/auth/components/login-form-card";
import { logger } from "@/libs/logger";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/auth/login")({
  component: AuthSignInPage,
});

const cLog = logger.child({ module: "AuthSignInPage" });

function AuthSignInPage() {
  cLog.info({ test: true }, "Rendering login page");
  useEffect(() => {
    cLog.info({ test: true }, "Login page mounted");
  }, []);
  return (
    <div className="flex items-center justify-center min-h-screen p-4 sm:p-0">
      <LoginFormCard />
    </div>
  );
}
